<template>
    <v-navigation-drawer
        v-model="active"
        right
        fixed
        temporary
        width="600"
    >
        <v-container v-if="active" class="pa-10">
            <v-row>
                <v-col>
                    <v-row>
                        <v-col class="py-0">
                            <span class="headline blue-grey--text text--darken-3">Ingreso de mercaderia</span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <provider-select
                        v-model="selectedProvider"
                    />

                    <inventory-item-select
                        v-model="selectedItem"
                    />

                    <v-text-field
                        ref="quantityField"
                        label="Cantidad"
                        v-model="quantity"
                        @focus="$event.target.select()"
                    ></v-text-field>

                    <v-text-field
                        label="Comentario"
                        v-model="comment"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>

        <template v-slot:append>
            <v-row class="ma-4">
                <v-spacer></v-spacer>

                <v-btn color="green" text @click="onCancelSelected">
                    Cancelar
                </v-btn>

                <v-btn color="green" dark @click="onConfirmSelected" :loading="isLoading">
                    Ingresar
                </v-btn>
            </v-row>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import ProviderSelect from '@/components/Production/ProviderSelect';
    import InventoryItemSelect from '@/components/Production/InventoryItemSelect';

    export default {
        components: {
            ProviderSelect,
            InventoryItemSelect
        },

        props: {
            value: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                active: false,

                selectedProvider: null,
                selectedItem: null,
                quantity: 0,
                comment: ''
            };
        },

        computed: {
            isLoading() {
                return false; // return this.$store.getters['stock/isLoading']();
            },

            isAddDisabled() {
                return !this.selectedProvider || !this.quantity || !this.selectedItem;
            }
        },

        watch: {
            active(val) {
                this.$emit('input', val);
            },

            value(val) {
                this.active = val;
            }
        },

        methods: {
            async onConfirmSelected(value) {
                let data = {
                    comment: this.comment,
                    item: this.selectedItem.id,
                    provider: this.selectedProvider.id,
                    quantity: Math.abs(parseInt(this.quantity))
                };

                await this.$store.dispatch('inventory/ingress', data);

                this.active = false;
            },

            onCancelSelected(value) {
                this.active = false;
            }
        }
    };
</script>
